import { Switch, Typography, Box } from '@mui/material';
import { DataSourceType } from '../../types/types';

interface DataSourceSwitcherProps {
  selected: DataSourceType;
  onChange: (view: DataSourceType) => void;
  disabled?: boolean;
}

export default function DataSourceSwitcher(props: DataSourceSwitcherProps) {
  const { selected, onChange, disabled = false } = props;
  const isCLImode = selected === 'cli';

  const handleToggle = () => {
    if (disabled) return;
    onChange(isCLImode ? 'api' : 'cli');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography
        sx={{
          fontWeight: !isCLImode ? 'bold' : 'normal',
          color: !isCLImode ? 'primary.main' : 'text.disabled',
        }}
      >
        API
      </Typography>
      <Switch
        checked={isCLImode}
        onChange={handleToggle}
        disabled={disabled}
        sx={{
          '& .MuiSwitch-switchBase': {
            color: 'primary.main',
          },
          '& .MuiSwitch-switchBase + .MuiSwitch-track': {
            backgroundColor: 'primary.main',
          },
        }}
      />
      <Typography
        sx={{
          fontWeight: isCLImode ? 'bold' : 'normal',
          color: isCLImode ? 'primary.main' : 'text.disabled',
        }}
      >
        CLI
      </Typography>
    </Box>
  );
}
